export default {
  path: '/material_colors',
  name: 'material_colors',
  component: () => import('../components/materialcolor/Layout'),
  redirect: { name: 'MaterialColorList' },
  meta: {
    breadcrumb: 'profile.material.colors',
  },
  children: [
    {
      name: 'MaterialColorList',
      path: '',
      component: () => import('../views/materialcolor/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'MaterialColorCreate',
      path: 'new',
      component: () => import('../views/materialcolor/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'MaterialColorUpdate',
      path: ':id/edit',
      component: () => import('../views/materialcolor/Update'),
      meta: {
        breadcrumb: 'profile.material.color',
      },
    },
    {
      name: 'MaterialColorShow',
      path: ':id',
      component: () => import('../views/materialcolor/Show'),
      meta: {
        breadcrumb: 'profile.material.color',
      },
    }
  ]
};
